import WarningBanner from './WarningBanner.component';

export default WarningBanner;
